module.exports = __webpack_public_path__ + "img/no_data.fcc23812.svg";